import React, { useContext, useLayoutEffect } from "react";
import { IKioskThemes } from "../../../../models/utilitiesModel";
import { useDispatch, useSelector } from 'react-redux';
import { ParentContext, SuperParentContext } from "../../Container/kioskcontext";
import "../../Kiosk.css";
import { IkioskManager, IKioskModel } from "models/kioskModel";

const ThemeOneKioskContainer: React.FC<any> = (props) => {
  const context = useContext(SuperParentContext);
  const selectionArea = useSelector((state: any) => {
    if (state?.kioskReducer?.selectedArea)
      return (state.kioskReducer as IKioskModel).selectedArea;
    else return IkioskManager.FIRSTPASSWELCOME;
  });
  console.log("ThemeOneKioskContainer =>", context);
  useLayoutEffect(() => {
    console.log("getThemeContainer=>1", props);
    if (props.theme === IKioskThemes.THEME1) document.body.className = "blue";
    else if (props.theme === IKioskThemes.THEME2)
      document.body.className = "light";
    else if (props.theme === IKioskThemes.THEME3)
      document.body.className = "dark";
    else document.body.className = "blue";
  }, []);

  return (
    <>
      <div className="kiosk-content bgImage">
        <>
          {selectionArea === IkioskManager.FIRSTPASSWELCOME ? <context.FirstpassHome /> : 
          <><ParentContext.Provider value={{ ThemeOneTime: context.ThemeOneTime }}>
            <context.ThemeOneTopBar />
          </ParentContext.Provider>
            <context.ThemeOneKioskManager />
            <context.ThemeOneFooter />
        </>}
        </>
        {false && <context.ThemeOneErrorBlock />}
      </div>
    </>
  );
};
export default ThemeOneKioskContainer;
